export default {
    API_ENDPOINT: 'https://cryptic-lake-76422.herokuapp.com/api',
    TOKEN_KEY: 'phone-triage-auth-token',
}